module.exports = __webpack_public_path__ + "static/t-bubble-1-a38e53cbfe609ba4faa698dada93df1c.png";